// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MRE6","title":"Header_title__1BPrD","side":"Header_side__3M2So"};